import { useController, type Control, type FieldValues, type Path } from 'react-hook-form'
import { Label } from '@/components/ui/label'
import { MaskedInput } from './masked-input'
import { maskCpf, stripDigits } from './masks'

interface CpfInputProps<T extends FieldValues> {
  control: Control<T>
  name: Path<T>
  label?: string
  disabled?: boolean
}

export function CpfInput<T extends FieldValues>({
  control,
  name,
  label = 'CPF',
  disabled,
}: CpfInputProps<T>) {
  const {
    field,
    fieldState: { error },
  } = useController({ control, name })

  return (
    <div className="space-y-1.5">
      <Label htmlFor={name}>{label}</Label>
      <MaskedInput
        id={name}
        value={(field.value as string) ?? ''}
        onChange={field.onChange}
        mask={maskCpf}
        strip={stripDigits}
        maxRaw={11}
        placeholder="000.000.000-00"
        aria-invalid={!!error}
        disabled={disabled}
        onBlur={field.onBlur}
      />
      {error && <p className="text-xs text-destructive">{error.message}</p>}
    </div>
  )
}
